import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import baseMessage from '../../components/baseMessage.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import ViewFooterBtn from '../../components/viewFooterBtn.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp/src/zbu.vue'
import TabsTrack from '../../components/tabsTrack.vue'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const activeKey = ref('base')
const operationLogRef = ref()
const detail = ref({})
// 标签页切换
const baseMessageRef = ref()
const contactsRef = ref()
const changeTabs = (v: string) => {
  switch (v) {
    case 'base':
      baseMessageRef.value?.fetch()
      break
    case 'contact':
      contactsRef.value?.refresh()
      break
    case 'operationLog':
      operationLogRef.value?.fetch()
      break
  }
}
const getDetail = (v: any) => {
  detail.value = v
}
const footerSuccess = (tag: 'contact') => {
  if (tag === 'contact') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  }
}
const permissionBase = {
  edit: 'lbu_lead_edit_btn',
  concat_add: 'lbu_lead_concat_add_btn'
}
const permissionConcat = {
  add: 'lbu_lead_concat_add_btn',
  edit: 'lbu_lead_concat_edit_btn',
  del: 'lbu_lead_concat_del_btn'
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                onChange: changeTabs,
                activeKey: activeKey.value,
                "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "base",
                    tab: "基本信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        ref_key: "baseMessageRef",
                        ref: baseMessageRef,
                        content: ['expectPushInfo'],
                        disabled: "",
                        view: "",
                        permissionPage: permissionBase,
                        onDetail: getDetail
                      }, null, 512)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "contact",
                    tab: "联系人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsContacts, {
                        ref_key: "contactsRef",
                        ref: contactsRef,
                        appId: "cos_zbu",
                        contactRefId: _unref(route).query.clueId,
                        permissionPage: permissionConcat
                      }, null, 8, ["contactRefId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "tabsFollowUp",
                    tab: "跟进情况"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsClueCosFollowUp, {
                        appId: "cos_zbu_lbu",
                        followRefId: _unref(route).query.trackAcceptorClueId
                      }, null, 8, ["followRefId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "tabsTrack",
                    tab: "跟踪情况"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsTrack, {
                        data: detail.value.track?.trackDetail
                      }, null, 8, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "operationLog",
                    tab: "操作日志"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        ref_key: "operationLogRef",
                        ref: operationLogRef,
                        tableId: "ZbuClueManageOperationLog",
                        resourceId: _unref(route).query.clueId,
                        appId: "cos_zbu"
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          }),
          _createVNode(ViewFooterBtn, {
            permissionPage: permissionBase,
            onSuccess: footerSuccess,
            detail: detail.value
          }, null, 8, ["detail"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})